import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { fetchInvestorInformations, parseInvestorInformations } from '../../investorInformation';
import { parser } from '../../utils/parsers';

export interface IShareholder extends IBaseSlice {
  tagline: string;
  title: string;
  items: Array<{
    title: string;
    annualReport: ILink;
    documents: Array<{
      title: string;
      link: ILink;
    }>;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
      }
    }
  }
`;

type NestedProps = {
  lang: string;
  limit?: number;
  previewData: boolean;
  redirects: Array<{ from: string; to: string }>;
};

export const fetchInvestorInformationsAndParse = async ({
  lang,
  limit,
  previewData,
  redirects = [],
}: NestedProps) => {
  const items = await fetchInvestorInformations(lang, '', previewData, (limit = 500));
  return parseInvestorInformations(items, redirects);
};

type Props = {
  primary: {
    slice_tagline: RichTextBlock[];
    slice_title: RichTextBlock[];
  };
};

export const parse = (slice: Props, redirects?): IShareholder => ({
  type: SliceTypes.Shareholder,
  tagline: parser.string(slice.primary.slice_tagline),
  title: parser.string(slice.primary.slice_title),
  items: [],
});
